module.exports = __webpack_public_path__ + "img/file_blue.6221e371.svg";